import React from 'react';
import { Box } from '@mui/material';
import { AuthorityOpticDropdown } from './authority-optic-dropdown';
import { useTenantConfiguration } from '../../../../hooks/use-tenant-configuration';
import { useAuthorityOptic, AuthorityOpticId } from './authority-optic-context';

export function AuthorityOpticSelectContainer() {
  const tenantConfiguration = useTenantConfiguration();
  const opticConfig = tenantConfiguration.authorityCitizenOpticSelection;

  const isEnabled = opticConfig?.enabled === true;

  const { selectedOpticId, setSelectedOpticId } = useAuthorityOptic();

  function handleSelectContext(contextId: AuthorityOpticId) {
    setSelectedOpticId(contextId);
  }

  if (!isEnabled) {
    return null;
  }

  return (
    <Box sx={{ ml: 1 }}>
      <AuthorityOpticDropdown
        selectedOpticId={selectedOpticId}
        onSelectOptic={handleSelectContext}
        availableOptics={opticConfig?.availableOptics}
        badgeLetterByOptic={opticConfig?.opticBadgeLetters}
      />
    </Box>
  );
}
